module.exports = "pegasus/assets/icn_1.png";